<style lang="stylus" scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
}

.demonstration {
  margin-right: 15px;
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.carWrap {
  padding: 20px;
  background: #fff;
  border-radius: 10px;

  main {
    flex: 1;
  }
}
</style>
<template>
  <div style class="carWrap">
    <exportDate v-if="showExport" @hideExport="hideExport1" :moduleName="moduleName"/>
    <div class="header">
      <div class="righth">
        <span class="demonstration">统计月份</span>
        <el-date-picker
          v-model="monTime"
          type="month"
          placeholder="选择月"
          @change="changeTime"
          value-format="yyyy-MM"
        ></el-date-picker>
        <!-- <span class="demonstration">品牌列表</span>
        <el-select v-model="value" placeholder="请选择">
          <el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
        </el-select>-->
      </div>
      <el-button v-show="hideExport" style="margin-left:15px;" @click="exportDate">导出</el-button>
    </div>
    <main>
      <Table :allData="allData" :index="indexAll"/>
    </main>
    <div class="block" style="width: fit-content; margin-left: auto; margin-right: auto;">
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        :page-size="20"
        @current-change="changeData"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import Table from './components/table' // 表格数据
import Cookies from 'js-cookie'
import http from '@/api/freight.js' //请求汇总
import { hideExport } from '@/utils/tools'
var now = new Date()
now.setMonth(now.getMonth() - 1)
export default {
  components: {
    Table
  },
  data() {
    return {
      hideExport:hideExport,
      moduleName: 'oilCollectionStat',
      showExport: false, //控制批量导出
      monTime: now, // 默认月份
      total: 50, // 总页数
      allData: [], // 总数据
      index: 1, // 当前页数
      endMonth: now, //请求日期
      pageSize: 20,
      indexAll: 0
      // options: ['中国石化', '中国石油', '其他油站', '加气站', '中海油'],
      // value: null
    }
  },
  mounted() {
    let that = this
    let time = that.monTime
    let year = time.getFullYear()
    let month = time.getMonth()
    that.endMonth = year + that.initMonth(month)
    this.initData()
  },
  methods: {
    initProvince() {},
    changeData(index) {
      let that = this
      that.index = index
      this.initData(1)
      that.indexAll = that.pageSize * (that.index - 1)
    },
    initData(num = 0) {
      let that = this
      http
        .carGas({
          page: that.index,
          pageSize: that.pageSize,
          countTime: that.endMonth,
          firstIs: num
        })
        .then(e => {
          if (e.data && e.data.tPageUtil && e.data.tPageUtil.list) {
            that.allData = [...e.data.tPageUtil.list]
            that.total = e.data.tPageUtil.count
            that.monTime = e.data.time
            //that.endMonth = year + that.initMonth(month)
          }
        })
    },
    changeTime() {
      let that = this
      let time = that.monTime
      let arr = time.split('-')
      that.endMonth = arr[0] + '' + arr[1]
      that.initData(1)
    },
    initMonth(num) {
      let newNum = num + 1
      return newNum < 10 ? '0' + newNum : newNum + ''
    },
    exportDate() {
      this.showExport = true
      return
    },
    // 取消导出
    hideExport1() {
      this.showExport = false
    }
  }
}
</script>